import { createContext } from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { EventHubsVM } from './event-hubs.viewmodel';

export const EventHubsContext = createContext<EventHubsVM>(null);
export const connectEventHubsVM = makeConnect(EventHubsContext);